/**
 * LandingFeaturesGrid — the dark "Built for the field" 6-card
 * features section. Direct visual mirror of NoRework's dark
 * features section: 2x3 grid, dark cards on dark background,
 * orange icon tiles, bold white titles, muted body copy.
 */

import { type ReactNode }                                                        from 'react'
import { Image as ImageIcon, Eye, WifiOff, Lock, FileSearch, Fingerprint }       from 'lucide-react'
import {
  FEATURES_HEADLINE,
  FEATURES_SUBHEAD,
  FEATURE_CARDS,
  type FeatureCard,
}                                                                                from './landingCopy'

const ICON_BY_NAME: Record<FeatureCard['icon'], typeof Eye> = {
  Image:       ImageIcon,
  Eye,
  WifiOff,
  Lock,
  FileSearch,
  Fingerprint,
}

export function LandingFeaturesGrid(): ReactNode {
  return (
    <section
      id="features"
      className="landing-section landing-section--ink"
      aria-labelledby="features-h"
    >
      <div className="landing-section__inner">
        <h2 id="features-h" className="landing-section__eyebrow">{FEATURES_HEADLINE}</h2>
        <p className="landing-section__lede">{FEATURES_SUBHEAD}</p>

        <div className="features-grid">
          {FEATURE_CARDS.map((card) => {
            const Icon = ICON_BY_NAME[card.icon]
            return (
              <article key={card.title} className="feature-card">
                <span className="icon-tile icon-tile--orange">
                  <Icon size={22} strokeWidth={2} />
                </span>
                <h3>{card.title}</h3>
                <p>{card.body}</p>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
